import { useDownload } from "../../../hooks/useDownload.ts";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { notifier } from "../../../utils/notifier.tsx";
import { RESOURCE_TYPE_TO_EXTENSION } from "../constants.ts";
import type { DownloadContent } from "../types.ts";
import { useCompileEditionCanvas } from "./useCompileEditionCanvas.ts";

export const useDownloadWithWatermark = () => {
  const { mutate: download, isLoading: isDownloading } = useDownload();
  const onBeforeDownload = useCompileEditionCanvas();
  const mutation = useAppMutation({
    path: "contents/download-with-watermark",
    invalidate: [],
    onSuccess: (response: { data: DownloadContent[] }) => {
      download({
        items: response.data.map((item) => ({
          url: item.download_url,
          filename: `${item.uuid}.${
            RESOURCE_TYPE_TO_EXTENSION[item.resource_type]
          }`,
          type: item.resource_type,
        })),
        onBeforeDownload,
        onError: () => {
          notifier.error("Download failed");
        },
      });
    },
  }).mutation;

  return {
    mutate: (uuids: string[]) => {
      mutation.mutate({ uuids });
    },
    isLoading: mutation.isLoading || isDownloading,
  };
};
